import { CommonEnums } from '../../common.enums';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';
import { Db_PropertyTypesUtil } from 'src/app/shared/utils/db_propertytypes.util';
import { Dashboards_Inst_CndsUtil } from 'src/app/shared/utils/dashboards_inst_cnds.util';
import { Dashboards_Inst } from './dashboards_inst';
import { Dashboards_Inst_Cnd } from './dashboards_inst_cnd';

export class Dashboards {
    dashboards_Inst: Dashboards_Inst;
    dashboards_Inst_Cnds: Array<Dashboards_Inst_Cnd>;

    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;

    nativeDbTyp_Id: number;
    ref_Id: number;
    ref_Cd: String;
    fldr_Id: number;
    is_In_SubFlow: string;
    interactive_Cnd_ID: number;
    sel_Run_PropertyType_Cd: string;

    change_Ind: string;
    gen_Tab_Change_Ind: string;
    conditions_Tab_Change_Ind: string;
    rProp_Tab_Change_Ind: string;

    error_Cd: string;
    error_Msg: string;
    static copyFrom: any;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.dashboards_Inst = new Dashboards_Inst();
        this.dashboards_Inst_Cnds = new Array<Dashboards_Inst_Cnd>();
        this.run_Properties = new Array<Obj_Db_Property>();
        this.runPropertyTypes = new Array<Db_PropertyType>();

        this.nativeDbTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.is_In_SubFlow = CommonEnums.defaults.STRING_EMPTY;
        this.interactive_Cnd_ID = CommonEnums.defaults.LONG_VAL;
        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;

        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.gen_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.conditions_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.rProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;

        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(dashboardsTmp: Dashboards): Dashboards {
        let dashboards: Dashboards = new Dashboards();
        Dashboards.copyFrom(dashboardsTmp);
        return dashboards;
    }

    copy(): Dashboards {
        let dashboardsTmp: Dashboards = new Dashboards();

        dashboardsTmp.dashboards_Inst = this.dashboards_Inst.copy();

        dashboardsTmp.dashboards_Inst_Cnds = Dashboards_Inst_CndsUtil.getInstance().copy(this.dashboards_Inst_Cnds);
        dashboardsTmp.run_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.run_Properties);
        dashboardsTmp.runPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.runPropertyTypes);

        dashboardsTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        dashboardsTmp.ref_Id = this.ref_Id;
        dashboardsTmp.ref_Cd = this.ref_Cd;
        dashboardsTmp.fldr_Id = this.fldr_Id;
        dashboardsTmp.is_In_SubFlow = this.is_In_SubFlow;
        dashboardsTmp.interactive_Cnd_ID = this.interactive_Cnd_ID;
        dashboardsTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;

        dashboardsTmp.change_Ind = this.change_Ind;
        dashboardsTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
        dashboardsTmp.conditions_Tab_Change_Ind = this.conditions_Tab_Change_Ind;
        dashboardsTmp.rProp_Tab_Change_Ind = this.rProp_Tab_Change_Ind;

        dashboardsTmp.error_Cd = this.error_Cd;
        dashboardsTmp.error_Msg = this.error_Msg;

        return dashboardsTmp;
    }

    copyFrom(dashboardsTmp: Dashboards): void {
        this.dashboards_Inst.copyFrom(dashboardsTmp.dashboards_Inst);

        Dashboards_Inst_CndsUtil.getInstance().copyFrom(this.dashboards_Inst_Cnds, dashboardsTmp.dashboards_Inst_Cnds);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.run_Properties, dashboardsTmp.run_Properties);
        Db_PropertyTypesUtil.getInstance().copyFrom(this.runPropertyTypes, dashboardsTmp.runPropertyTypes);

        this.nativeDbTyp_Id = dashboardsTmp.nativeDbTyp_Id;
        this.ref_Id = dashboardsTmp.ref_Id;
        this.ref_Cd = dashboardsTmp.ref_Cd;
        this.fldr_Id = dashboardsTmp.fldr_Id;
        this.is_In_SubFlow = dashboardsTmp.is_In_SubFlow;
        this.interactive_Cnd_ID = dashboardsTmp.interactive_Cnd_ID;
        this.sel_Run_PropertyType_Cd = dashboardsTmp.sel_Run_PropertyType_Cd;

        this.change_Ind = dashboardsTmp.change_Ind;
        this.gen_Tab_Change_Ind = dashboardsTmp.gen_Tab_Change_Ind;
        this.conditions_Tab_Change_Ind = dashboardsTmp.conditions_Tab_Change_Ind;
        this.rProp_Tab_Change_Ind = dashboardsTmp.rProp_Tab_Change_Ind;

        this.error_Cd = dashboardsTmp.error_Cd;
        this.error_Msg = dashboardsTmp.error_Msg;
    }

    compare(dashboardsTmp: Dashboards): string {
        let diffString: string = this.dashboards_Inst.compare(dashboardsTmp.dashboards_Inst);
        if (diffString != '') return diffString;

        diffString = this.toBaseCompare(dashboardsTmp);
        if (diffString != '') return diffString;

        diffString = Dashboards_Inst_CndsUtil.getInstance().compare(this.dashboards_Inst_Cnds, dashboardsTmp.dashboards_Inst_Cnds);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.run_Properties, dashboardsTmp.run_Properties);
        if (diffString != '') return diffString;

        diffString = Db_PropertyTypesUtil.getInstance().compare(this.runPropertyTypes, dashboardsTmp.runPropertyTypes);
        if (diffString != '') return diffString;

        return '';
    }

    toBaseCompare(dashboardsTmp: Dashboards): string {
        let baseString: string = this.toBaseString();
        let baseTmpString: string = dashboardsTmp.toBaseString();

        if (baseString != baseTmpString) {
            return baseString + ', ' + baseTmpString;
        }

        return '';
    }

    toBaseString(): string {
        return ", interactive_Cnd_ID =" + this.interactive_Cnd_ID +
            ", is_In_SubFlow =" + this.is_In_SubFlow + ", sel_Run_PropertyType_Cd =" + this.sel_Run_PropertyType_Cd;
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Dashboards [dashboards_Inst =" + this.dashboards_Inst.toString() +
            ", dashboards_Inst_Cnds=" + Dashboards_Inst_CndsUtil.getInstance().toString(this.dashboards_Inst_Cnds) +
            ", run_Properties =" + Obj_Db_PropertiesUtil.getInstance().toString(this.run_Properties) +
            ", runPropertyTypes =" + Db_PropertyTypesUtil.getInstance().toString(this.runPropertyTypes);

        if (isNotCompare) {
            str += ", change_Ind=" + this.change_Ind + ", nativeDbTyp_Id=" + this.nativeDbTyp_Id +
                ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg +
                ", ref_Id =" + this.ref_Id + ", ref_Cd =" + this.ref_Cd + ", fldr_Id =" + this.fldr_Id +
                ", gen_Tab_Change_Ind =" + this.gen_Tab_Change_Ind +
                ", conditions_Tab_Change_Ind =" + this.conditions_Tab_Change_Ind +
                ", rProp_Tab_Change_Ind =" + this.rProp_Tab_Change_Ind;
        }

        str += ']';
        return str;
    }
}